import React from "react";

import { Box, Flex, Heading } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { IndeedProIcon } from "../../../lib/IndeedProIcon";
import { ApplicantInsightsPopoverIcon } from "./ApplicantInsightsPopoverIcon";

type ApplicantInsightsHeaderProps = {
  showPopover: boolean;
  showBranding: boolean;
};

const ApplicantInsightsHeader: React.FC<ApplicantInsightsHeaderProps> = (props) => {
  const { showPopover, showBranding } = props;
  const gt = useI18n();

  return (
    <Box>
      <Flex
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBlockStart: 24,
        }}
      >
        <Flex sx={{ flexDirection: "column" }}>
          {showBranding && (
            <Flex
              sx={{
                flexDirection: "row",
                gap: 4,
                alignItems: "center",
              }}
            >
              <Box aria-hidden={true}>
                <IndeedProIcon width={20} height={20} />
              </Box>
              <Heading
                level={2}
                sx={{
                  fontWeight: "bold",
                }}
              >
                {gt.gettext("Indeed Pro")}
              </Heading>
            </Flex>
          )}
        </Flex>

        {showPopover && <ApplicantInsightsPopoverIcon />}
      </Flex>
      <Heading level={2} sx={{ marginBlockStart: showBranding ? 24 : 0, fontWeight: "bold" }}>
        {gt.gettext("Applicant insights")}
      </Heading>
    </Box>
  );
};

export default ApplicantInsightsHeader;
